import { styled } from "@mui/material/styles";

import { useTranslation } from "@/lib/i18n";

/*
    styled are copied from _compontents.map.scss from old source code (source-exons-client) 
    NOTE: this is not a good practice, but it's a quick solution to migrate the old code to new one
*/
const StyledFigure = styled("figure")(({ theme }) => ({
  maxWidth: "15em",
  position: "absolute",
  fontSize: "0.875em",
  top: "2.5em",
  right: "0em",
  zIndex: 1004,
  background: theme.palette.grey[400],
  padding: "0.6em",
  boxShadow: " 0 0 0 0px rgba(0,0,0,0.4);",

  "&:after": {
    position: "absolute",
    content: "",
    borderWidth: "0.5em 0.5em 0.75em 0.5em",
    borderStyle: "solid",
    borderColor: `transparent transparent ${theme.palette.grey[400]} transparent`,
    top: "-1.15em",
    right: "7.1em",
  },

  "@media (min-width: 64em)": {
    fontSize: "0.7em",
    top: "2.45em",
  },
}));

const LegendBlock = ({ image }: { image: string }) => {
  const { t } = useTranslation();
  return (
    <StyledFigure>
      <figcaption>{t("common.legend")}</figcaption>
      <img src={image} alt={t("common.legend")} />
    </StyledFigure>
  );
};

export default LegendBlock;
